import { PaymentMethodValueT } from './payment-method';

/* eslint-disable sort-keys */
export const PAYMENT_DAY_OPTIONS = {
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
} as const;
/* eslint-enable sort-keys */

export type PaymentDayValueT = keyof typeof PAYMENT_DAY_OPTIONS;

export type PaymentDayLabelT = typeof PAYMENT_DAY_OPTIONS[PaymentDayValueT];

export type PaymentDayOptionT = {
  label: PaymentDayLabelT;
  value: PaymentDayValueT;
};

export const paymentDayOptions: PaymentDayOptionT[] = (Object
  .entries(PAYMENT_DAY_OPTIONS) as [PaymentDayValueT, PaymentDayLabelT][])
  .map(([value, label]) => ({ label, value }));

/* eslint-disable sort-keys */
export const PAYMENT_DAYS_OPTIONS = {
  '1_and_15': '1st and 15th of every month',
  '1_and_16': '1st and 16th of every month',
  '5_and_20': '5th and 20th of every month',
  '7_and_22': '7th and 22nd of every month',
  '10_and_25': '10th and 25th of every month',
  '15_and_last': '15th and last day of every month',
} as const;
/* eslint-enable sort-keys */

export type PaymentDaysValueT = keyof typeof PAYMENT_DAYS_OPTIONS;

export type PaymentDaysLabelT = typeof PAYMENT_DAYS_OPTIONS[PaymentDaysValueT];

export type PaymentDaysOptionT = {
  label: PaymentDaysLabelT;
  value: PaymentDaysValueT;
};

export const paymentDaysOptions: PaymentDaysOptionT[] = (Object
  .entries(PAYMENT_DAYS_OPTIONS) as [PaymentDaysValueT, PaymentDaysLabelT][])
  .map(([value, label]) => ({ label, value }));

/* eslint-disable sort-keys */
export const PAYMENT_SCHEDULE_OPTIONS = {
  same_day_each_month: 'Same day of each month',
  same_day_particular_week: 'Same day of a particular week',
} as const;
/* eslint-enable sort-keys */

export type PaymentScheduleValueT = keyof typeof PAYMENT_SCHEDULE_OPTIONS;

export type PaymentScheduleLabelT = typeof PAYMENT_SCHEDULE_OPTIONS[PaymentScheduleValueT];

export type PaymentScheduleOptionT = {
  label: PaymentScheduleLabelT;
  value: PaymentScheduleValueT;
};

export const paymentScheduleOptions: PaymentScheduleOptionT[] = (Object
  .entries(PAYMENT_SCHEDULE_OPTIONS) as [PaymentScheduleValueT, PaymentScheduleLabelT][])
  .map(([value, label]) => ({ label, value }));

/* eslint-disable sort-keys, quote-props */
export const MONTHLY_PAYMENT_DAY_OPTIONS = {
  '1': '1st',
  '2': '2nd',
  '3': '3rd',
  '4': '4th',
  '5': '5th',
  '6': '6th',
  '7': '7th',
  '8': '8th',
  '9': '9th',
  '10': '10th',
  '11': '11th',
  '12': '12th',
  '13': '13th',
  '14': '14th',
  '15': '15th',
  '16': '16th',
  '17': '17th',
  '18': '18th',
  '19': '19th',
  '20': '20th',
  '21': '21st',
  '22': '22nd',
  '23': '23rd',
  '24': '24th',
  '25': '25th',
  '26': '26th',
  '27': '27th',
  '28': '28th',
  '29': '29th',
  '30': '30th',
  last_day: 'Last Day',
} as const;
/* eslint-enable sort-keys, quote-props */

export type MonthlyPaymentDayValueT = keyof typeof MONTHLY_PAYMENT_DAY_OPTIONS;

export type MonthlyPaymentDayLabelT =
  typeof MONTHLY_PAYMENT_DAY_OPTIONS[MonthlyPaymentDayValueT];

export type MonthlyPaymentDayOptionT = {
  label: MonthlyPaymentDayLabelT;
  value: MonthlyPaymentDayValueT;
};

export const monthlyPaymentDayOptions: MonthlyPaymentDayOptionT[] = (Object
  .entries(MONTHLY_PAYMENT_DAY_OPTIONS) as [MonthlyPaymentDayValueT, MonthlyPaymentDayLabelT][])
  .map(([value, label]) => ({ label, value }));

/* eslint-disable sort-keys */
export const PAYMENT_WEEK_OPTIONS = {
  first: 'First',
  second: 'Second',
  third: 'Third',
  fourth: 'Fourth',
  last: 'Last',
} as const;
/* eslint-enable sort-keys */

export type PaymentWeekValueT = keyof typeof PAYMENT_WEEK_OPTIONS;

export type PaymentWeekLabelT = typeof PAYMENT_WEEK_OPTIONS[PaymentWeekValueT];

export type PaymentWeekOptionT = {
  label: PaymentWeekLabelT;
  value: PaymentWeekValueT;
};

export const paymentWeekOptions: PaymentWeekOptionT[] = (Object
  .entries(PAYMENT_WEEK_OPTIONS) as [PaymentWeekValueT, PaymentWeekLabelT][])
  .map(([value, label]) => ({ label, value }));

/* eslint-disable sort-keys */
export const PAYMENT_FREQUENCY_OPTIONS = {
  biweekly: 'Every other week',
  twice_monthly: 'Twice per month',
  monthly: 'Once per month',
  weekly: 'Once per week',
} as const;
/* eslint-enable sort-keys */

export type PaymentFrequencyValueT = keyof typeof PAYMENT_FREQUENCY_OPTIONS;

export type PaymentFrequencyLabelT = typeof PAYMENT_FREQUENCY_OPTIONS[PaymentFrequencyValueT];

export type PaymentFrequencyOptionT = {
  label: PaymentFrequencyLabelT;
  value: PaymentFrequencyValueT;
};

export const paymentFrequencyOptions: PaymentFrequencyOptionT[] = (Object
  .entries(PAYMENT_FREQUENCY_OPTIONS) as [PaymentFrequencyValueT, PaymentFrequencyLabelT][])
  .map(([value, label]) => ({ label, value }));

export type IncomeDetailsFormT = {
  amount: number;
  frequency: PaymentFrequencyValueT;
  method: PaymentMethodValueT;
  monthlyPaymentDay?: MonthlyPaymentDayValueT;
  monthlyWeekDay?: PaymentDayValueT;
  nextPayday?: string;
  payDay?: PaymentDayValueT;
  paymentDays?: PaymentDaysValueT;
  paymentSchedule?: PaymentScheduleValueT;
  paymentWeek?: PaymentWeekValueT;
};
